import { render, staticRenderFns } from "./ServiceContainerMenu.vue?vue&type=template&id=57dd85cb"
import script from "./ServiceContainerMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceContainerMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports